export default __webpack_public_path__ + "static/media/J720_RoHS.f5e6ce4d.pdf";